// @flow

import React from "react"
import { Link } from "react-router-dom"

type Props = {
  children: Object,
  to?: Object,
  onClick?: Function,
  style?: Object
}

const TextLink = ({
  children,
  to,
  onClick,
  style
}: Props): React$Element<any> | React$Element<"a"> => {
  if (onClick) {
    return (
      <a onClick={onClick} style={style}>
        {children}
      </a>
    )
  } else {
    return (
      <Link to={to} style={style}>
        {children}
      </Link>
    )
  }
}

export default TextLink
